// extracted by mini-css-extract-plugin
export const mainLogo = "styles-module--mainLogo--iF-Na";
export const logo = "styles-module--logo--3Jp5Z";